import Header from "./Header";
import Footer from "./Footer";
import { FiTrash2 } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./WishlistPage.css"
function WishlistPage({ hideLayout = false }) {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCartPopup, setShowCartPopup] = useState(false);
const [selectedProduct, setSelectedProduct] = useState(null);

  const notifyHeaderUpdate = (detail = {}) => {
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail,
    })
  );
};
  const getUserGuestPayload = (createGuest = false) => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");
  const userId = storedUser?.id || "";

  let guestId = localStorage.getItem("guest_id") || "";

  if (!userId && createGuest && !guestId) {
    guestId = `guest_${Date.now()}`;
    localStorage.setItem("guest_id", guestId);
  }

  return userId
    ? { user_id: userId, guest_id: "" }
    : { guest_id: guestId, user_id: "" };
};
const isInCart = (productId) => {
  return cartItems.some(
    (item) => Number(item.product_id) === Number(productId)
  );
};
const fetchCart = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/cart-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      setCartItems(data.data || []);
    } else {
      setCartItems([]);
    }
  } catch (err) {
    console.error(err);
  }
};

const fetchWishlist = async () => {
  try {
    setLoading(true);

    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) {
      setWishlist([]);
      return;
    }

    const res = await fetch(
      "https://aethearia.store/superadmin/api/wishlist-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      setWishlist(data.data || []);
    } else {
      setWishlist([]);
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

const removeWishlistItem = async (wishlist_id) => {
  const oldWishlist = [...wishlist];

  const updatedWishlist = wishlist.filter(
    (item) => Number(item.wishlist_id) !== Number(wishlist_id)
  );

  // instant UI update
  setWishlist(updatedWishlist);

  // instant header wishlist count update
  notifyHeaderUpdate({
    wishlistCount: updatedWishlist.length,
  });

  try {
    const payload = {
      ...getUserGuestPayload(),
      wishlist_id,
    };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/delete-wishlist",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (!data.status) {
      // rollback if API failed
      setWishlist(oldWishlist);

      notifyHeaderUpdate({
        wishlistCount: oldWishlist.length,
      });
    }
  } catch (err) {
    console.error(err);

    // rollback if error
    setWishlist(oldWishlist);

    notifyHeaderUpdate({
      wishlistCount: oldWishlist.length,
    });
  }
};

const moveToCart = async (item) => {
  const productId = Number(item.product_id || item.id);

  if (isInCart(productId)) return;

  const oldCartItems = [...cartItems];

  const updatedCartItems = [
    ...cartItems,
    {
      product_id: productId,
    },
  ];

  setCartItems(updatedCartItems);

  notifyHeaderUpdate({
    cartCount: updatedCartItems.length,
  });

  try {
    const payload = {
      ...getUserGuestPayload(true),
      product_id: productId,
      variant_id: Number(item.variant_id || 1),
      quantity: 1,
    };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/add-to-cart",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      setSelectedProduct({
        img: `https://aethearia.store/superadmin/uploads/products/Hero/${item.hero_image}`,
        name: item.product_name,
        catname: item.catname || item.category_name || "",
        price: item.min_price,
        offerPrice: item.min_offer_price,
      });

      setShowCartPopup(true);

      await removeWishlistItem(item.wishlist_id);

      await fetchCart();

      window.dispatchEvent(new Event("cartWishlistUpdated"));
    } else {
      setCartItems(oldCartItems);

      notifyHeaderUpdate({
        cartCount: oldCartItems.length,
      });
    }
  } catch (err) {
    console.error(err);

    setCartItems(oldCartItems);

    notifyHeaderUpdate({
      cartCount: oldCartItems.length,
    });
  }
};

  useEffect(() => {
    fetchWishlist();
      fetchCart();
  }, []);

  return (
    <>
     {!hideLayout && <Header />}

      <section className="wishlist-page">

        

        {wishlist.length === 0 ? (
          <div className="empty-wishlist">
            <h3>Your wishlist is empty</h3>
             <p>Add products to your cart and continue shopping.</p>
            <button
              onClick={() => navigate("/shop-all")}
              className="shop-btn"
            >
              Shop Now
            </button>
          </div>
        ) : (
          <>
            <div className="wishlist-top">
          <h1 className="wishlist-title">
            My Wishlist
          </h1>
          
          <Link
            to="/shop-all"
            className="continue-link"
          >
            Continue shopping
          </Link>
        </div>

         <div className="wishlist-grid">
            {wishlist.map((item) => (
<div className="wishlist-card" key={item.wishlist_id}>

  <div className="wishlist-product">

    {/* Mobile Remove Button */}
    <button
      className="wishlist-mobile-remove"
      onClick={() => removeWishlistItem(item.wishlist_id)}
      aria-label="Remove from wishlist"
    >
      ✕
    </button>

    <img
      src={`https://aethearia.store/superadmin/uploads/products/Hero/${item.hero_image}`}
      alt={item.product_name}
      onClick={() =>
        navigate(`/product/${item.product_slug}`)
      }
      style={{ cursor: "pointer" }}
    />

    <div className="wishlist-content">

      <h3
        onClick={() =>
          navigate(`/product/${item.product_slug}`)
        }
        style={{ cursor: "pointer" }}
      >
        {item.product_name}
      </h3>

      <div className="wishlist-price">
        ₹
        {Number(item.min_offer_price) > 0
          ? item.min_offer_price
          : item.min_price}
      </div>

      <div className="wishlist-actions">

        {/* Add To Cart */}
        <button
          className={`cart-btn ${
            isInCart(item.product_id || item.id)
              ? "added-cart-btn"
              : ""
          }`}
          disabled={isInCart(item.product_id || item.id)}
          onClick={() => moveToCart(item)}
        >
          {isInCart(item.product_id || item.id)
            ? "Added"
            : "+ Add To Cart"}
        </button>

        {/* Desktop Remove Button */}
        <button
          className="delete-btn wishlist-desktop-remove"
          onClick={() =>
            removeWishlistItem(item.wishlist_id)
          }
        >
          <FiTrash2 />
        </button>

      </div>
    </div>
  </div>
</div>
            ))}
            </div>
          </>
        )}
      </section>
{showCartPopup && selectedProduct && (
  <div className="cart-popup-overlay">
    <div className="cart-popup">
      <button
        className="popup-close"
        onClick={() => setShowCartPopup(false)}
      >
        ✕
      </button>

      <div className="popup-top">
        <span>✓</span>
        <p>Item added to your cart</p>
      </div>

      <div className="popup-product">
        <img src={selectedProduct.img} alt={selectedProduct.name} />

        <div>
          <h4>{selectedProduct.name}</h4>

          {selectedProduct.catname && (
            <p>{selectedProduct.catname}</p>
          )}

          <span>
            ₹
            {Number(selectedProduct.offerPrice) > 0
              ? selectedProduct.offerPrice
              : selectedProduct.price}
          </span>
        </div>
      </div>

      <button
        className="view-cart-btn"
        onClick={() => navigate("/cart")}
      >
        View cart
      </button>

      <button
        className="checkout-btn"
        onClick={() => navigate("/checkout")}
      >
        Check out
      </button>

      <button
        className="continue-btn"
        onClick={() => setShowCartPopup(false)}
      >
        Continue shopping
      </button>
    </div>
  </div>
)}
{!hideLayout && <Footer />}
    </>
  );
}

export default WishlistPage;